// extracted by mini-css-extract-plugin
export default {"links_container":"NetworkLinks_links_container__LDA4p","network_link_item":"NetworkLinks_network_link_item__nuXWG"};